<div class="min-h-screen flex bg-shikenso-base-white">
  <div class="flex-[0.5] flex flex-col items-center mx-auto my-auto">
    <div class="flex w-full items-center justify-center mb-12">
      <img src="images/logo/logo.png" alt="Logo" width="36" />
    </div>

    <div class="bg-shikenso-gray-base px-14 py-10 rounded-2xl max-w-[440px]">
      <div class="flex flex-col items-center justify-center gap-2 mb-6 px-6">
        <h1 class="text-[28px] font-bold text-black">{{ 'pages.newPassword.title' | translate }}</h1>
        <p class="text-shikenso-gray-700 text-sm text-center">{{ 'pages.newPassword.description' | translate }}</p>
      </div>

      <form [formGroup]="passwordForm" class="custom-form flex flex-col gap-2" (ngSubmit)="onSubmit()">
        <mat-form-field class="w-full">
          <mat-label>{{ 'pages.newPassword.newPassword' | translate }}</mat-label>
          <input matInput [type]="showPassword() ? 'text' : 'password'" formControlName="password" />
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="!bg-transparent mat-big-icon-button"
            (click)="showPassword.set(!showPassword())"
          >
            @if (showPassword()) {
              <app-icon src="/icons/view-off.svg" alt="View off" />
            } @else {
              <app-icon src="/icons/view.svg" alt="View" />
            }
          </button>
          <mat-error [control]="passwordForm.get('password')" />
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>{{ 'pages.newPassword.confirmNewPassword' | translate }}</mat-label>
          <input matInput [type]="showConfirmPassword() ? 'text' : 'password'" formControlName="confirmPassword" />
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="!bg-transparent mat-big-icon-button"
            (click)="showConfirmPassword.set(!showConfirmPassword())"
          >
            @if (showConfirmPassword()) {
              <app-icon src="/icons/view-off.svg" alt="View off" />
            } @else {
              <app-icon src="/icons/view.svg" alt="View" />
            }
          </button>
          <mat-error [control]="passwordForm.get('confirmPassword')" />
        </mat-form-field>

        <!-- Buttons -->
        <button mat-flat-button color="primary" type="submit" class="w-full" [disabled]="loading()">
          @if (loading()) {
            <app-dots-spinner />
          } @else {
            {{ 'pages.newPassword.resetPassword' | translate }}
          }
        </button>
      </form>
    </div>
  </div>

  <div class="flex-[0.5] login-image"></div>
</div>
